import { useQuery } from 'react-query';
import { JobPermissionService } from '../../../services/v1/applicant_tracking/JobPermissionService';

export const useJobUnpublishPermissions = (jobId: number, expand?: string[]) =>
  useQuery({
    queryKey: ['job_unpublish_permissions', jobId, { expand: expand }],
    queryFn: () => JobPermissionService.unpublish(jobId, expand),
  });
